const mutations = {
    incrementLoadingCount (state) {
        ++state.loadingCount
    },
    decrementLoadingCount (state) {
        if (state.loadingCount > 0) {
            --state.loadingCount
        }
    }
};

export default mutations;